// Hand-maintained bridge: the `gql` document function is generated by the client preset
// under `./operations/`. This file keeps the historical `__generated__/gql` import path stable.
export * from "./operations/gql";
